// Gestion de la barre de progression sur les cartes produits
document.addEventListener('DOMContentLoaded', function() {
  const productCards = document.querySelectorAll('.product-card');
  
  productCards.forEach(card => {
    const slideshowSlides = card.querySelector('slideshow-slides');
    const progressBars = card.querySelectorAll('.product-card-progress-bar');
    
    if (!slideshowSlides || progressBars.length === 0) return;
    
    const updateProgress = function() {
      const scrollLeft = slideshowSlides.scrollLeft;
      const slideWidth = slideshowSlides.offsetWidth;
      const currentIndex = Math.round(scrollLeft / slideWidth);
      
      progressBars.forEach((bar, index) => {
        if (index === currentIndex) {
          bar.style.backgroundColor = 'rgba(0, 0, 0, 0.9)';
        } else {
          bar.style.backgroundColor = 'rgba(255, 255, 255, 0.4)';
        }
      });
    };
    
    // Écouter le scroll - CHANGEMENT EN TEMPS RÉEL
    slideshowSlides.addEventListener('scroll', updateProgress);
    
    // Init
    updateProgress();
  });
});